import { render } from "./FileManagerEditImage.vue?vue&type=template&id=13f44454"
import script from "./FileManagerEditImage.vue?vue&type=script&lang=js"
export * from "./FileManagerEditImage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__